<span *ngIf="inContainer; else freeLabel" [style.--order]="order" class=" d-inline-flex border-slightly-faded
  align-items-center m-1 padding-2  mb-0 mr-3 rounded-medium {{animation}}"
>
  <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
</span>

<ng-template #freeLabel>
  <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
</ng-template>

<ng-template #labelTpl>
  <span (click)="click.emit(true)" [matTooltip]="toolTip" [ngClass]="{
      'text-primary border-primary_ bg-gradient-faded': active,
      'border-on-hover': !active
    }" [style.--order]="order+0.4" class="px-2 p-2 rounded-medium border-slightly-faded
    cursor-pointer animate bg-slightly-faded-gradient  d-flex align-items-center
     bg-hover-slightly-gradient {{'scale-up'}}"
        style="height: fit-content;">
    <span class="ps-1 d-inline-flex align-items-center text-nowrap">
      <mat-icon *ngIf="(icon | iconType) === 'SVG'"
                [svgIcon]="icon" class="{{label ?'me-2' :''}} {{iconClass}}"></mat-icon>
      <mat-icon *ngIf="(icon | iconType) === 'MATERIAL'"
                class="{{label ?'me-2' :''}} {{iconClass}}">{{icon}}</mat-icon>
      <span class="top--1">
        <span *ngIf="label" class="text-bold d-inline-block m-0 pe-2"> {{label}}</span>
        <span *ngIf="subLabel" class="faded ps-1"> {{ subLabel}}</span>
      </span>
    </span>
  </span>
</ng-template>

